import { render, staticRenderFns } from "./DashboardCommerce.vue?vue&type=template&id=98849b60"
import script from "./DashboardCommerce.vue?vue&type=script&lang=js"
export * from "./DashboardCommerce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports